import { applyAuth0Theme } from "@/utils/theme/themeEngine";

import PasskeyEnrollmentLocalForm from "./components/PasskeyEnrollmentLocalForm";
import { usePasskeyEnrollmentLocalManager } from "./hooks/usePasskeyEnrollmentLocalManager";
import { AuthLayout } from "@/components/auth/AuthLayout";

function PasskeyEnrollmentLocalScreen() {
    // Extracting attributes from hook made out of PasskeyEnrollmentLocalInstance class of Auth0 React ACUL SDK
    const { texts, locales, passkeyEnrollmentLocalInstance } =
        usePasskeyEnrollmentLocalManager();

    // Apply theme from SDK instance when screen loads
    applyAuth0Theme(passkeyEnrollmentLocalInstance);
    return (
        // Applying UDS theme overrides using the "theme-universal" class
        <AuthLayout title={texts?.pageTitle || locales.page.title}>

            <PasskeyEnrollmentLocalForm />

        </AuthLayout>
    );
}

export default PasskeyEnrollmentLocalScreen;
